const getAge = (dateString) => {
  if (!dateString) {
    return " ";
  }
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
const getDOB = (age) => {
  if (!age) {
    return " ";
  }
  var today = new Date();
  var birthYear = today.getFullYear() - age;
  var birthDate = new Date(birthYear, 0, 1);

  return birthDate;
};

const getTime = (dateString) => {
  var time = dateString.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  return time;
};

const getDateMMYY = (dateString) => {
  const month = dateString.getMonth();
  const year = dateString.getFullYear();

  return `${month + 1}/${year}`;
};

const getDDMMYY = (dateString) => {
  if (!dateString) {
    return "";
  }

  return new Date(dateString).toLocaleDateString("en-GB");
};

const slashToHyphenDate = (dateItem) => {
  var dateObj = new Date(dateItem);
  var month = dateObj.getMonth() + 1; //months from 1-12
  var day = dateObj.getDate();
  var year = dateObj.getFullYear();
  var monthl = `${month}`.length;
  var dayl = `${day}`.length;
  var newdate =
    year +
    "-" +
    `${dayl < 2 ? "0" + day : day}` +
    "-" +
    `${monthl < 2 ? "0" + month : month}`;
  // var newdate =
  //   year +
  //   "-" +
  //   `${monthl < 2 ? "0" + month : month}` +
  //   "-" +
  //   `${dayl < 2 ? "0" + day : day}`;
  // var newdate = day + "/" + `${l < 2 ? "0" + month : month}` + "/" + year;
  return newdate;
};

const getGenderCode = (genderString) => {
  return genderString === "Female" ? "F" : "M";
};

const truncate = (string, anchor) => {
  if (string.length <= 90) return string;
  return anchor
    ? string.slice(0, 79) + `...${anchor}`
    : string.slice(0, 79) + `...`;
};

export {
  getAge,
  getDOB,
  getTime,
  getDateMMYY,
  getDDMMYY,
  slashToHyphenDate,
  getGenderCode,
  truncate,
};
